import { render, staticRenderFns } from "./ChatFaceSelect.vue?vue&type=template&id=5f72efe6&lang=pug&"
import script from "./ChatFaceSelect.vue?vue&type=script&lang=ts&"
export * from "./ChatFaceSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatFaceSelect.vue"
export default component.exports